import { useMemo } from "react";
import {
  Box,
  HStack,
  Text,
  Stack,
  VStack,
  CircularProgress,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

import Button from "components/Button/Button";
import HistoryItem from "components/AffiliateItems/HistoryItem";
import WalletBalance from "components/WalletBalance/WalletBalance";

// import useWallet from "hooks/useWalletBalance";

import {
  useGetAffiliateEarningsQuery,
  useGetAffiliateEarningSummaryQuery,
} from "services/walletApi";

import take from "lodash/take";
import isEmpty from "lodash/isEmpty";
import toPrecision from "util/toPrecision";

export default function RewardHistoryAffiliatePanel(props) {
  const { data, isLoading } = useGetAffiliateEarningsQuery();
  const { data: summaryData, isLoading: isSummaryLoading } =
    useGetAffiliateEarningSummaryQuery();

  const earnings = useMemo(() => data?.earnings, [data]);
  const combinedEarns = useMemo(
    () => summaryData?.combinedEarns,
    [summaryData]
  );

  const bonuses = useMemo(() => {
    const keys = Object.keys(combinedEarns ?? {});
    return keys?.map((key) => ({ coin: key, bonus: combinedEarns[key] }));
  }, [combinedEarns]);

  console.log("EARNINGS HISTORY", earnings);

  const history = useHistory();

  return (
    <Box>
      <Stack>
        {/* {isSummaryLoading && (
          <CircularProgress
            py="20px"
            isIndeterminate
            color="green.400"
            size="18px"
          />
        )} */}
        {!isSummaryLoading &&
          bonuses?.map((item, i) => (
            <WalletBalance
              minW="100%"
              coin={item.coin}
              balance={item.bonus}
              precision={12}
              forcePrecision={true}
              onClick={() =>
                history.push(`/dashboard/account/partners/rewards/${item.coin}`)
              }
              key={`crypto-wallet-balance-${i}`}
            />
            // <Text>
            //   {item.coin} {item.bonus}
            // </Text>
          ))}
      </Stack>

      <Box mt="40px">
        <HStack justifyContent="space-between" mb="20px">
          <Text fontSize="18px" fontWeight="600" color="#14142B">
            Earnings
          </Text>

          <Button
            //   disabled={!isEligible}
            variant="ghost"
            bg="transparent"
            size="sm"
            color="#03A438"
            minW="fit-content"
            onClick={() => history.push(`/dashboard/account/partners/earnings`)}
          >
            View all
          </Button>
        </HStack>

        <Stack>
          {/* {Array(4)
            .fill(0)
            .map((_, i) => (
              <HistoryItem
                key={`reward-list-${i}`}
                to={`/dashboard/account/partners/earnings/${i + 1}`}
              />
            ))} */}

          <VStack>
            {isLoading && (
              <CircularProgress
                disabled
                isIndeterminate
                color="#a7a7a7"
                size="32px"
              />
            )}

            {!isLoading && isEmpty(earnings) && <Text>History not found</Text>}
          </VStack>

          {take(earnings, 4)?.map((ref, i) => (
            <HistoryItem
              _for="earnings"
              key={`earnings-history-${i}`}
              // to={`/dashboard/account/partners/invites/${ref?._id}`}
              name={ref?.referredUserId?.fullName}
              email={`${toPrecision(
                ref?.value?.$numberDecimal,
                ref?.unit,
                true,
                8,
                true
              )} ${ref?.description}`}
              createdAt={ref?.createdAt}
              onClick={() =>
                history.push(
                  `/dashboard/account/partners/earnings/${ref?._id}`,
                  ref
                )
              }
            />
          ))}
        </Stack>
      </Box>
    </Box>
  );
}
